import { render, staticRenderFns } from "./TeamRequestDetail.vue?vue&type=template&id=ff0cb1a4&scoped=true"
import script from "./teamRequestDetail.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestDetail.vue?vue&type=style&index=0&id=ff0cb1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0cb1a4",
  null
  
)

export default component.exports